import React from 'react';
import {
  Button, Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText,
} from '@mui/material';

import PropTypes from 'prop-types';
import './ConfirmDialog.scss';

const ConfirmDialog = ({
  title, text, visible, onCancel, onConfirm, showTitle, cancelLabel, confirmLabel,
  showCancelButton,
}) => (
  <Dialog
    open={visible}
    onClose={onCancel}
    className="confirm-dialog"
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    { showTitle && (
      <DialogTitle id="alert-dialog-title" className="confirm-dialog__title">
        { title }
      </DialogTitle>
    )}
    <DialogContent className="confirm-dialog__content">
      <DialogContentText id="alert-dialog-description">
        {text}
      </DialogContentText>
    </DialogContent>
    <DialogActions className="confirm-dialog__actions" sx={{ p: 2 }}>
      {showCancelButton && (
      <Button
        type="submit"
        variant="contained"
        onClick={onConfirm}
        className="confirm-dialog__actions-action"
      >
        {confirmLabel}
      </Button>
      )}
      <Button
        variant="outlined"
        onClick={onCancel}
        className="confirm-dialog__actions-action"
      >
        {cancelLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

ConfirmDialog.propTypes = {
  visible: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  text: PropTypes.string,
  showTitle: PropTypes.bool,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  showCancelButton: PropTypes.bool,
};

ConfirmDialog.defaultProps = {
  visible: false,
  showTitle: true,
  showCancelButton: true,
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
  title: 'Are you sure you want to leave page?',
  text: 'Data you have entered would not be saved.',
};

export default ConfirmDialog;
